import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row, Spinner, Stack, Table, Form, Modal, FormLabel, FormGroup } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";

import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";

import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import ".././../assets/css/ListComponentsTable.css"
import { ROUTES } from "../../constants/webRouting";
import { formatDate, formatDateForView, getUserDetails } from "../../utils/helper";
import UserSiteVisitModal from "../siteVisit/UserSiteVisitModal";
import InfoPill from "../InfoPill";
import { DateRangePicker } from "rsuite";
import Select from "react-select";
import * as constants from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";
import moment from "moment";//Added by shahir hussain 06-01-2026
import PubSub from "pubsub-js";
import UserMultiSelect from "../common/UserMultiSelect";


const UserTracking = () => {
    const userInfo = getUserDetails();
    const [body, setBody] = useState();
    // visit data 
    const [visitData, setVisitData] = useState(null);
    const [filterData, setFilterData] = useState({ visit_status: "Pending" });
    const [assignUsers, setAssignUsers] = useState([]);
    const [modalShowUserSiteVisit, setModalShowUserSiteVisit] = useState(false);
    const [dateRange, setDateRange] = React.useState([
        // new Date(),
        // new Date()
    ]);
    const [statusArray, setStatusArray] = useState(
        constants.SITE_VISIT_STATUS
    );

    //Added this all by shahir hussain 06-01-2026
    const [changeOwnerModal, setChangeOwnerModal] = useState(false);
    const [refreshRecords, setRefreshRecords] = useState(false);
    const [ownerLeads, setOwnerLeads] = useState([]);
    const [ownerLeadsHeader, setOwnerLeadsHeader] = useState([]);
    const [fromUser, setFromUser] = useState({});
    const [toUser, setToUser] = useState({});
    const tableRef = useRef(null);
    const [users, setUsers] = useState([]);
    const [spinnerForChangeOwner, setSpinnerForChangeOwner] = useState(false);
    const [leadCities, setLeadCities] = useState([]);
    const [selectedToUsers, setSelectedToUsers] = useState([]);
    //Ended this all by shahir hussain 06-01-2026

    useEffect(() => { console.log('visitData', visitData) }, [visitData]);
    useEffect(() => {
        const filter = { ...filterData };
        delete filter.owner_name;
        filter.owner_ids = filter?.owner_ids?.filter((item) => (item.value))?.map((item) => item.value);
        if (Array.isArray(dateRange) && dateRange.length > 0) filter.date_range = { filed: 'createddate', createddate: { from: formatDate(dateRange?.at(0) || null), to: formatDate(dateRange?.at(1) || null), } };
        fetchUserTrackings(filter);
    }, [dateRange, filterData]);

    async function init() {
        if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
        })) {
            const resultedUsers = await fuziElevatorsApi.fetchUsers();
            resultedUsers && Array.isArray(resultedUsers) && setAssignUsers(
                resultedUsers.map((user) => ({
                    value: user.id,
                    label: user.username,
                }))
            );
        }
    }

    async function fetchUserTrackings(filters) {
        const result = await fuziElevatorsApi.fetchUserTrackings(filters);
        if (result) {
            setBody(result);
        } else {
            setBody([]);
        }
    }

    useEffect(() => {
        init();
    }, []);

    const submitSiteVisit = () => {
        setModalShowUserSiteVisit((prev) => !prev);
        init();
        fetchUserTrackings(filterData);
    };
    const editUser = (visitData) => {
        setVisitData(visitData);
        setModalShowUserSiteVisit((prev) => !prev);
    }
    // Create table headers consisting of 4 columns.
    // Randomize data of the table columns.
    // Note that the fields are all using the `prop` field of the headers.
    const header = [];
    if (!isMobile) {
        header.push(
            { title: 'Enquiry No', prop: 'enquiry_no', cell: (row) => <Link to={`${ROUTES.LEAD.LIST}/${row.parentid}`} state={{ id: row.parentid }}> {row.enquiry_no} </Link>, isFilterable: true, isSortable: true, },
            //formatDateForView added by shahir hussain 27-08-2025
            {
                title: "Created Date",
                prop: "createddate",
                isFilterable: true,
                cell: (row) => (
                    row?.createddate ? formatDateForView(row.createddate) : ''
                ),
                isSortable: true,
            },
            { title: 'Lead Name', prop: 'lead_name', isFilterable: true, isSortable: true, },
            {
                title: "Address",
                prop: "address",
            },

            {
                title: "City",
                prop: "city",
                isFilterable: true,
            },

            {
                title: "Phone",
                prop: "phone",
                isFilterable: true,
            },

            {
                title: "Make",
                prop: "accounts",
                // cell: (row) => (

                //     row.accounts?.map((item) =>
                //         item?.value && <>
                //             <Link to={`${ROUTES.ACCOUNT.LIST}/${item.value}`} >
                //                 {item.label}
                //             </Link>
                //             <br />
                //         </>

                //     )),

                cell: (row) => {
                    if (!row.accounts || row.accounts.length === 0) return "-";

                    return (
                        <span>
                            {row.accounts.map((item, index) => (
                                item?.value && (
                                    <span key={item.value}>
                                        <Link
                                            to={`${ROUTES.ACCOUNT.LIST}/${item.value}`}
                                            style={{ marginRight: "4px" }}
                                        >
                                            {item.label}
                                        </Link>
                                        {index < row.accounts.length - 1 && ", "}
                                    </span>
                                )
                            ))}
                        </span>
                    );
                },
                isFilterable: true,
            },

            {
                title: "Lead Type",
                prop: "leadtype",
                isFilterable: true,
                isSortable: false,
            },
            { title: 'Remarks', prop: 'remarks' },
            // { title: 'Visit Status', prop: 'visit_status', isFilterable: true },
            {
                title: "Visit Status",
                prop: "visit_status",
                isFilterable: true,
                isSortable: true,
                alignment: { horizontal: "center" },
                cell: (row) => (
                    <span
                        className="badge rounded-pill w-100"
                        style={getStatusClass(row.visit_status)}
                    >
                        {row.visit_status}
                    </span>
                ),
            },
            // { title: 'Assign User', prop: 'owner_name', cell: (row) => <Link to={`${ROUTES.USER.LIST}/${row.owner_id}`} state={row}> {row.owner_name} </Link>, isFilterable: true },
            {
                title: "Assigned Users",
                prop: "owner_ids",
                cell: (row) => (
                    <div className="d-flex flex-wrap gap-1">
                        {row.owner_ids?.map((item, index) =>
                            item?.value && (
                                <Link
                                    key={index}
                                    to={`${ROUTES.USER.LIST}/${item.value}`}
                                    state={row}
                                    className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
                                    style={{
                                        background: "#f5f7fa",
                                        border: "1px solid #e0e0e0",
                                        transition: "0.2s",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "#eaf1ff")}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = "#f5f7fa")}
                                >
                                    {/* <img
                                src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                                className="rounded-circle"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  objectFit: "cover",
                                  border: "2px solid #007bff",
                                }}
                                alt=""
                              /> */}
                                    <span className="fw-semibold text-primary">{item.label}</span>
                                </Link>
                            )
                        )}
                    </div>
                ),

                isFilterable: true,
            },
            {
                title: "Actions",
                prop: "id",
                cell: (row) => {
                    if ([PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_SITE_VISIT].some(permission => {
                        return userInfo?.permissions?.map(p => p.name).includes(permission);
                    })) {
                        if (!row.logindatetime) {
                            return < Button
                                size="sm"
                                variant="success"
                                onClick={() => { row.action = "check-in"; editUser(row); }}
                            >
                                Check-In
                            </Button >
                        } else if (!row.logoutdatetime) {
                            return < Button
                                size="sm"
                                variant="danger"
                                onClick={() => { row.action = "check-out"; editUser(row); }}
                            >
                                Check-Out
                            </Button >
                        }
                    }
                }
            },

        );
    } else {
        //for mobile device
        header.push({
            title: "Info",
            prop: "name",
            isFilterable: true,
            isSortable: true,
            cell: (row) => (
                <div className="mobilecard">
                    <Link
                        to={`${ROUTES.CONTACT.LIST}/${row.id}`}
                        state={row}
                        style={{ width: "100%" }}
                    >
                        {row.firstname} {row.lastname}
                    </Link>

                    <span>
                        <i className="fa-solid fa-phone"></i> {row.phone}
                    </span>
                    <span style={{ width: "80%" }}>
                        <i className="fa-solid fa-envelope"></i> {row.email}
                    </span>
                </div>
            ),
        });
    }

    const labels = {
        beforeSelect: " ",
    };

    const handleChange = (e) => {
        setFilterData((pre) => ({ ...pre, [e.target.name]: e.target.value }));
    };

    const handleClear = () => {
        setFilterData({});
        fetchUserTrackings();
    };

    const getStatusClass = (status) => {
        const statusObj = constants.SITE_VISIT_STATUS.find(
            (value) => value.label === status
        );
        return statusObj ? statusObj.css : {};
    };

    //Added by shahir hussain for change user 06-01-2026
    useEffect(() => {
        (async () => {
            try {
                const fetchUsers = await fuziElevatorsApi.fetchUsersForListPage();
                if (Array.isArray(fetchUsers)) {
                    setUsers(fetchUsers?.map(({ id, username, userrole }) => ({ value: id, label: `${username} - ${userrole}` })));
                } else {
                    setUsers([]);
                }
            } catch (error) {
                console.error("Failed to load users/contacts:", error);
                setUsers([]);
            }

        })();
    }, []);

    //Added by shahir hussain for change user 06-01-2026
    useEffect(() => {
        (async () => {
            if (fromUser && fromUser?.value) {
                setSpinnerForChangeOwner(true);
                const leads = await fuziElevatorsApi.getSiteVisitsByStaffId(fromUser?.value);
                if (leads.success) {

                    setOwnerLeads(leads?.data);
                    setOwnerLeadsHeader([
                        {
                            title: <Form.Check // prettier-ignore
                                type={"checkbox"}
                                label="Select All"
                                name="all_leads"
                                onChange={handelCheckBox}
                            />,
                            prop: "id",
                            isFilterable: true,
                            cell: (row) => (
                                <Form.Check // prettier-ignore
                                    type={"checkbox"}
                                    id={`${row.id}`}
                                    name="leads"
                                />
                            ),
                        },
                        {
                            title: "Lead Name",
                            prop: "lead_name",
                            isFilterable: true,
                            cell: (row) => (
                                // <Link to={"/leads/" + row.parentid} state={row}>
                                //     {row.lead_name}
                                // </Link>
                                <Link to={`${ROUTES.LEAD.LIST}/${row.parentid}`} state={{ id: row.parentid }}> {row.lead_name} </Link>
                            ),
                        },
                        {
                            title: "Visit Status",
                            prop: "visit_status",
                            isFilterable: true, isSortable: true,
                            // cell: (row) => {
                            //   return (
                            //     <Badge bg={getStatusClass(row.lead_status)} style={{ display: "block", paddingBottom: "5px" }}>
                            //       {row.lead_status}
                            //     </Badge>
                            //   );

                            // },
                        },
                        {
                            title: "Created Date", prop: "createddate", isSortable: true, isFilterable: true, cell: (row) => (
                                <span>
                                    {moment(row.createddate).format('DD-MM-yyyy')}
                                </span>
                            )
                        },
                        {
                            title: "Assigned",
                            prop: "ownername",
                            isFilterable: true,
                            isSortable: true,
                            cell: (row) => {
                                const titleAbbreviations = {
                                    "Sales Admin": "S. S.",
                                    "Installation Admin": "I. A.",
                                    "Accounts": "ACCOUNTS",
                                    "Accounts Admin": "A. A.",
                                    "Installation Engineer": "I. E.",
                                    "Installation Supervisor": "I. S.",
                                    "Business Development Executive": "B. D. E.",
                                    "Customer Relationship Executive": "C. R. E.",
                                    "Office": "OFFICE",
                                    "Office Coordinator": "O. C.",
                                    "Office Executive": "O. E.",
                                    "Service Admin": "S. R.",
                                    "SUPER_ADMIN": "SUPER_ADMIN" // If no abbreviation is needed
                                };


                                // Split ownername and ownerid arrays
                                const ownerNames = row.ownername ? row.ownername.split(', ') : [];
                                const ownerIds = row.ownerid ? row.ownerid : [];

                                // Function to shorten titles
                                const shortenTitle = (name) => {
                                    const [fullName, title] = name.split(' - ');
                                    const shortTitle = titleAbbreviations[title.trim()] || title; // Use abbreviation if available
                                    return `${fullName} - ${shortTitle}`;
                                };

                                // Ensure ownerNames and ownerIds arrays are of the same length
                                const links = ownerNames.map((name, index) => (
                                    <Link
                                        key={index} // Use index as key if ownerIds[index] is not reliable
                                        to={`/users/${ownerIds[index]}`}
                                        state={row}
                                        className="align-items-center justify-content-start"
                                    >
                                        {shortenTitle(name)}<br />
                                    </Link>
                                ));
                                return <span>{links}</span>;
                            },
                        },
                    ]);
                }
                else {
                    setOwnerLeads([]);
                    setOwnerLeadsHeader([]);
                }
                setSpinnerForChangeOwner(false);
            } else {
                setOwnerLeads([]);
                setOwnerLeadsHeader([]);
            }
        })();
    }, [fromUser])

    //Added by shahir hussain for change user 06-01-2026
    const handelChangeOwnerModalClose = () => {
        setChangeOwnerModal(false);
        setRefreshRecords(!(refreshRecords));
        setOwnerLeads([]);
        setOwnerLeadsHeader([]);
        setFromUser({});
        setToUser({});
        setSelectedToUsers([])
    }

    //Added by shahir hussain for change user 06-01-2026
    const ChangeOwner = (e) => {
        e.preventDefault();
        let leads = [...(tableRef?.current?.querySelectorAll(`input[name='leads']`))];
        leads = leads?.filter((elm) => (elm.checked));
        leads = leads?.map((elm) => (elm.id));

        const toUsers = selectedToUsers.map(u => u.value);
        (async () => {
            const result = await fuziElevatorsApi.ChangeSiteVisitsOwner({ fromUser: fromUser.value, toUser: toUsers, leads });
            if (result.success) {
                PubSub.publish('RECORD_SAVED_TOAST', { title: 'Transfer Owner', message: 'Owner Transfer successfully' });
                setSelectedToUsers([]);
                handelChangeOwnerModalClose();
            } else {
                PubSub.publish('RECORD_ERROR_TOAST', { title: 'Transfer Owner Error', message: 'Some error occurred' });
            }
        })();
    }

    //Added by shahir hussain for change user 06-01-2026
    const handelFromUserSelect = (e) => {
        if (e) {
            setFromUser(e);
        }
        else {
            setFromUser(e);
        }
    }
    const handelCheckBox = (e) => {
        [...(tableRef.current.querySelectorAll(`input[name='leads']`))].forEach((elm) => {
            elm.checked = e.target.checked;
        })
    }

    return (
        <Container fluid>
            <DatatableWrapper
                body={(body && Array.isArray(body)) ? body : []}
                headers={header}
                paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 50,
                        options: [5, 10, 15, 20, 30, 50]
                    },
                }}
                sortProps={{ initialState: { prop: 'createddate', order: "desc" } }}
            >
                <Row className="">
                    <Col lg={3}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label>Site Status</Form.Label>
                            <Form.Select
                                name="visit_status"
                                value={filterData?.visit_status || ""}
                                onChange={handleChange}
                            >
                                <option value="">--Select-Status--</option>
                                {statusArray.map((item, index) => (
                                    <option value={item.label} key={index}>
                                        {item.label}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicLeadManagerId"
                            >
                                Assigned User
                            </Form.Label>
                            <Select
                                // isClearable
                                className="z-3"
                                isMulti
                                name="owner_ids"
                                classNamePrefix="react-select"
                                onChange={(e) => {
                                    handleChange({
                                        target: { name: "owner_ids", value: e },
                                    });
                                }}
                                value={
                                    filterData?.owner_ids?.filter((item) => (item.value))
                                }
                                options={assignUsers}
                            />
                        </Form.Group>
                    </Col>
                    {/* <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicUsers">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicState"
                            >
                                Users
                            </Form.Label>

                            <Select
                                isMulti
                                placeholder="Select your Users"
                                isClearable
                                options={assignUsers}
                                onChange={(e) => {
                                    handleChange({
                                        target: { name: "owner_ids", value: e },
                                    });
                                }}
                                value={
                                    filterData?.owner_ids?.filter((item) => (item.value))
                                }
                            ></Select>
                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col> */}

                </Row>
                <Row className="align-items-end">
                    <Col>
                        <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
                    </Col>
                    <Col
                        md={1}
                    >
                        <PaginationOptions labels={labels} />
                    </Col>
                    <Col>
                        <DateRangePicker
                            value={dateRange}
                            onChange={(e) => { setDateRange(e) }}
                            // format="dd/mm/yyyy"
                            character=" – "
                        />
                    </Col>
                    <Col className="py-1">
                        <BrowserView>
                            <div className="d-flex py-1 px-2 ">
                                <InfoPill left="Total" right={body?.length} rightClasses="bg-custom text-white border-white fw-bold" leftClasses="bg-white text-danger fw-bold " />
                            </div>
                        </BrowserView>
                    </Col>
                    <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                    >
                        <Stack direction="horizontal" gap={2}>
                            {/* <Button
                                size="sm"
                                className="btn-create"
                                onClick={() => createContact(true)}
                            >
                                New Site Visit
                            </Button> */}
                            {/* <Button variant="success" onClick={handleSearch}><i class="fas fa-search"></i></Button> */}
                            {/* Added by shahir hussain for change user 06-01-2026  */}
                            {userInfo?.userrole === "SUPER_ADMIN" && (
                                <Button onClick={() => (setChangeOwnerModal(true))} className="btn-sm" >Transfer Owner</Button>
                            )
                            }
                            <Button variant="secondary" onClick={handleClear}><i class="fa fa-refresh" aria-hidden="true"></i></Button>
                        </Stack>
                    </Col>
                </Row>

                {/* <Table striped className="shadow rounded sm my-4" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {
                        (body && Array.isArray(body)) ?
                            <TableBody />
                            :
                            <tbody className="">
                                <tr>
                                    <td colSpan={100} align="center">
                                        <div>
                                            <Spinner />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                    }
                </Table> */}
                <div className="table-scroll my-3">
                    <Table striped className="shadow rounded sm my-4">
                        <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
                        {
                            (body && Array.isArray(body)) ?
                                <TableBody />
                                :
                                <tbody className="">
                                    <tr>
                                        <td colSpan={100} align="center">
                                            <div>
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                        }
                    </Table>
                </div>
                <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
            </DatatableWrapper>
            {
                modalShowUserSiteVisit &&
                <UserSiteVisitModal
                    show={modalShowUserSiteVisit}
                    onHide={() => setModalShowUserSiteVisit(false)}
                    visitData={visitData}
                    submitSiteVisit={submitSiteVisit}
                />
            }
            {/* Add this modal by shahir hussain 06-01-2026 */}
            {changeOwnerModal && <Modal
                show={changeOwnerModal}
                onHide={handelChangeOwnerModalClose}
                size={"xl"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Transfer Owner
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={ChangeOwner} >
                    <Modal.Body >
                        <Row className="gap-3">
                            <Col lg={12} >
                                <Row className="">
                                    <Col lg={6}>
                                        <FormGroup>
                                            <FormLabel>From</FormLabel>
                                            <Select
                                                isClearable
                                                options={users}
                                                onChange={handelFromUserSelect}
                                                name="fromUser"
                                                required
                                            >
                                            </Select>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={6}>
                                        <FormGroup>
                                            {/* <FormLabel>To</FormLabel>
                      <Select
                        isClearable
                        options={users}
                        onChange={handelToUserSelect}
                        name="toUser"
                        required
                      >
                      </Select> */}
                                            <UserMultiSelect
                                                options={users}
                                                value={selectedToUsers}
                                                onChange={setSelectedToUsers}
                                                label="To"
                                            />
                                        </FormGroup>
                                    </Col>

                                </Row>
                            </Col>
                            <Col lg={12} >
                            </Col>
                        </Row>
                        {/* New Change : Enhanced the UI and adder loader */}
                        {(fromUser && Object.keys(fromUser)?.length > 0) &&
                            <Container style={{ height: "50vh", overflowY: "auto" }}>

                                {!spinnerForChangeOwner ?
                                    <DatatableWrapper
                                        body={ownerLeads}
                                        headers={ownerLeadsHeader}
                                    >
                                        <Table striped className="data-table" ref={tableRef}>
                                            <TableHeader />
                                            <TableBody />
                                        </Table>
                                    </DatatableWrapper>
                                    :
                                    <div className="d-flex justify-content-center align-items-center mt-5" >
                                        <Spinner animation="border" variant="secondary" size="lg" />
                                    </div>
                                }
                            </Container>
                        }


                    </Modal.Body>
                    <Modal.Footer>
                        <div className='submit'>
                            <Button variant="success" type="submit" >
                                Change
                            </Button>
                        </div>
                        <Button onClick={handelChangeOwnerModalClose} variant="light">
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>}
        </Container >
    );
};

export default UserTracking;
